import React, { FC, memo, useCallback, useContext } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
import { NavigationTypes } from "@swiggy-private/native-bridge";
import { getBridgeSdk } from "@swiggy-private/checkout-core";
// constants
import { CTA } from "@super-ui/components/m2c-swiggy-one-halfcard/types";
import { M2C_HALFCARD_TEST_IDS } from "@super-ui/components/m2c-swiggy-one-halfcard/constants";
// styles
import { CtaContainer, ViewAllBenefitsButton } from "../styles";
// contexts
import { M2CHalfcardContext } from "@super-ui/contexts";
interface CTAProps {
    ctas: CTA[];
    addSuperFromTGBottomsheet: (ctaText: string) => void;
    addingSuperToCart: boolean;
    setAddingSuperToCart: (addingSuperToCart: boolean) => void;
}

const PreStateCtas: FC<CTAProps> = ({
    ctas = [],
    addSuperFromTGBottomsheet,
    addingSuperToCart,
    setAddingSuperToCart,
}) => {
    const [addCta, viewAllBenefitsCta] = ctas;
    const {
        analyticsEvents: {
            onImpressionM2CHalfcardAddCta,
            onImpressionM2CHalfcardSkipCta,
            onClickM2CHalfcardViewAllBenefitsCta,
        },
    } = useContext(M2CHalfcardContext);

    useEffectOnce(() => {
        onImpressionM2CHalfcardAddCta(addCta?.text || "");
        onImpressionM2CHalfcardSkipCta(viewAllBenefitsCta?.text || "");
    });

    const primaryCtaAction = useCallback(() => {
        setAddingSuperToCart(true);
        addSuperFromTGBottomsheet(addCta?.text || "");
    }, [addCta?.text, addSuperFromTGBottomsheet, setAddingSuperToCart]);

    const secondaryCtaAction = useCallback(
        (link: string) => {
            if (!isEmpty(link)) {
                onClickM2CHalfcardViewAllBenefitsCta(viewAllBenefitsCta?.text, link);

                getBridgeSdk().navigateToScreen({
                    type: NavigationTypes.DEEPLINK,
                    link,
                    params: {
                        shouldCloseWebview: false,
                    },
                });
            }
            return;
        },
        [onClickM2CHalfcardViewAllBenefitsCta, viewAllBenefitsCta?.text],
    );

    return (
        <CtaContainer>
            {!isEmpty(addCta?.text) && (
                <SuperButton
                    data-testid={M2C_HALFCARD_TEST_IDS.PRIMARY_CTA}
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="large"
                    onClick={primaryCtaAction}
                    loading={addingSuperToCart}
                >
                    <Text variant="V2.subheading1.neutral.bold" color="primary_One_Blck">
                        {addCta?.text}
                    </Text>
                </SuperButton>
            )}
            {!isEmpty(viewAllBenefitsCta?.text) && (
                <ViewAllBenefitsButton
                    onClick={() => secondaryCtaAction(viewAllBenefitsCta?.link || "")}
                    data-testid={M2C_HALFCARD_TEST_IDS.SECONDARY_CTA}
                >
                    <Text variant="V2.body2.neutral.bold" color="primary">
                        {viewAllBenefitsCta?.text}
                    </Text>
                </ViewAllBenefitsButton>
            )}
        </CtaContainer>
    );
};

export default memo(PreStateCtas);
